import React, { useState } from 'react';

// Emergency contact (from the practice's PDF intake): first/last name, phone,
// relationship. Same form conventions as ShippingAddressStep. Answer:
// { firstName, lastName, phone, relationship }.
const EmergencyContactStep = ({ question, value, onAnswer, onNext }) => {
  const [form, setForm] = useState({
    firstName: value?.firstName || '',
    lastName: value?.lastName || '',
    phone: value?.phone || '',
    relationship: value?.relationship || '',
  });
  const [errors, setErrors] = useState({});

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const validate = () => {
    const next = {};
    if (!form.firstName.trim()) next.firstName = 'First name is required';
    if (!form.lastName.trim()) next.lastName = 'Last name is required';
    if (form.phone.replace(/\D/g, '').length < 10) next.phone = 'Please enter a valid phone number';
    if (!form.relationship.trim()) next.relationship = 'Relationship is required';
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onAnswer({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      phone: form.phone.trim(),
      relationship: form.relationship.trim(),
    });
    onNext();
  };

  const field = (key, label, extra = {}) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={`ec-${key}`}>{label}</label>
      <input
        id={`ec-${key}`}
        type={extra.type || 'text'}
        value={form[key]}
        onChange={set(key)}
        placeholder={extra.placeholder || ''}
        autoComplete={extra.autoComplete || 'off'}
        className={`form-input ${errors[key] ? 'error' : ''}`}
        data-testid={`emergency-${key}`}
      />
      {errors[key] && <p className="text-sm text-red-500 mt-1">{errors[key]}</p>}
    </div>
  );

  return (
    <div data-testid={`step-${question.id}`}>
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">{question.question}</h2>
      {question.subtitle && <p className="text-center text-gray-500 mb-8">{question.subtitle}</p>}
      <form onSubmit={handleSubmit} noValidate className="max-w-md mx-auto space-y-4">
        <div className="grid grid-cols-2 gap-4">
          {field('firstName', 'First name', { autoComplete: 'off' })}
          {field('lastName', 'Last name')}
        </div>
        {field('phone', 'Phone number', { type: 'tel', placeholder: '(555) 123-4567', autoComplete: 'tel' })}
        {field('relationship', 'Relationship to you', { placeholder: 'e.g., Spouse, Parent, Friend' })}
        <button type="submit" className="btn-primary mt-6" data-testid="continue-button">Continue</button>
      </form>
    </div>
  );
};

export default EmergencyContactStep;
